import ACTIONS from ".";
import axios from "../../utils/axios";

export const dispatchSignIn = () => {
  return {
    type: ACTIONS.SIGN_IN,
  };
};

export const dispatchSignOut = () => {
  return {
    type: ACTIONS.SIGN_OUT,
  };
};

export const fetchUser = (token) => async (dispatch) => {
  const res = await axios.get("/api/user/info", {
    headers: { Authorization: token },
  });

  dispatch({
    type: ACTIONS.GET_USER,
    payload: res.data,
  });
  return res;
};
